exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ModalStyles_modalposOS__2wTHM {\n    width: 95%;\n    height: 90%;\n    margin-top: 3vh;\n    margin-left:1vw;\n  \n  }\n\n  .ModalStyles_modalinfo__1h_Nn {\n    padding: 20px;\n    background-color: #0065B0;\n    color: white;\n    font-weight: bold;\n    text-align: center;\n    padding: 7px;\n    font-size: 16px;\n    font-family: blinker;\n  \n  }", ""]);

// exports
exports.locals = {
	"modalposOS": "ModalStyles_modalposOS__2wTHM",
	"modalinfo": "ModalStyles_modalinfo__1h_Nn"
};